import * as React from 'react';
import Popper from '@mui/material/Popper';
import Paper from "@mui/material/Paper";

import NativeSelect from '@mui/material/NativeSelect';
import DonemOptions from "../DonemOptions";
import IconButton from "@mui/material/IconButton";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

const WidgetPeriodSelection = ({periodId, setPeriodId}) => {

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);


    return (
        <div style={{position: "absolute", top: -10, right: 1}}>
            <IconButton onClick={handleClick}>
                <MoreVertOutlinedIcon/>
            </IconButton>

            <Popper open={open} anchorEl={anchorEl}>
                <Paper>
                    <div style={{padding: 16, backgroundColor: 'white'}}>
                        <NativeSelect
                            defaultValue={periodId}
                            value={periodId}
                            onChange={(e) => {
                                setPeriodId(e.target.value);
                                setAnchorEl(null);
                            }}>
                            <DonemOptions/>
                        </NativeSelect>
                    </div>
                </Paper>
            </Popper>
        </div>
    )
}

export default WidgetPeriodSelection;
